module.exports = __webpack_public_path__ + "img/lct_icon1.6ba465f8.svg";